module.exports = __webpack_public_path__ + "static/media/task6Planet3.d98cee5c.png";